import React from "react";

const ProjectAside = ({
  active,
  title,
  description,
  slug,
  backgroundColor
}) => {
  if (!active) return null;
  return (
    <aside className="container project__info">
      <div className="row">
        <div className="column column--4">
          <a className="project__info__link" href={`/project/${slug}`}>
            <h2>
              <span
                className="project__info__indicator"
                style={{ backgroundColor }}
              />
              <em>{title}</em>
            </h2>
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
            <p>
              <u>View Project</u>
            </p>
          </a>
        </div>
      </div>
    </aside>
  );
};

export default ProjectAside;
